import "@babel/polyfill";

window.ExURL = require('./exceptions-url.js');
require('./bootstrap');

// require('./jquery-3.4.1.min.js');
require('popper.js');
require('bootstrap');
require('animsition');
require('jquery-form');
require('jquery-mousewheel');
// require('jquery-asScrollbar');
// require('jquery-asScrollable');
require('jquery-asHoverScroll');
require('jquery-match-height');

require('jquery-sticky-element/jquery.stickyelement.js');

require('stickybits/src/jquery.stickybits.js');

require('jquery-pjax');

require('floatthead/src/jquery.floatThead.js');

window.Plyr = require('plyr');

window.introJs = require('./intro.js');

window.jsYaml = require('js-yaml/dist/js-yaml.js');

// require('Component.js');
// require('Plugin.js');
// require('Base.js');

window.Config = require('Config.js');

require('material_center/babel-external-helpers.js');  //REMARK
require('material_center/popper.min.js');   //REMARK
require('material_center/jquery-asScrollbar.js');   //REMARK
require('material_center/jquery-asScrollable.js');  //REMARK
require('material_center/jquery-slidePanel.js');  //REMARK

require('material_center/global/Component.js'); //REMARK
require('material_center/global/Plugin.js');    //REMARK
require('material_center/global/Base.js');  //REMARK
require('material_center/global/Config.js');    //REMARK


require('Menubar.js'); // Section REMARK
require('Sidebar.js'); // Section REMARK
require('PageAside.js'); // Section REMARK
require('material_center/plugin/menu.js'); // Section REMARK
// require('material_center/plugin/slidepanel.js'); // Section REMARK

window.Site = require('material_center/Site.js'); // Section REMARK
require('material_center/plugin/asscrollable.js'); // Section REMARK


require('GridMenu.js'); // Section/


// require('Plugin/menu.js');

require('config/colors.js');

// window.Site = require('Site.js');


// require('Plugin/asscrollable.js');
require('Plugin/matchheight.js');

require('./main.js');
require('./filtres.js');
require('./jquery.raty.js');
require('./ratingHelper.js');

require('./pjax-setter.js');
//require('jquery-ui');

//менюшка и слайд панель
require('./menu_and_slide.js');
// require('./components/bootstrap-datepicker.min.js');
require('./components/bootstrap-clockpicker.min.js');

require('./onlineconsultant.js');
require('./messager.js');
require('./charts.min.js');
require('./AjaxErrorBallon.js');


require('./AutoSaveExam.js');
require('./inputText.js');

//require('./guide.js');
require('./menu.js');
require('./croppie.js');
// require('./sweetalert.min.js');
//require('./promise.min.js');
//require('./toastr.min.js');

require('./upload_logo_company.js');
require('./company_report_header.js');

require('./upload_photo_udo.js');
require('./exam_results.js');

require('masonry-layout/dist/masonry.pkgd');

window.datepicker = require('bootstrap-datepicker');
require('icheck');
window.toastr = require('toastr');
window.Swal = require('./sweetalert2.all.js'); //8.8.5
window.swal = window.Swal;
window.newSwal = require('./sweetalert2');
// window.Swal = require('sweetalert2'); //11.7.2
window.jstree = require("jstree/dist/jstree.js");
require('./scormAPILib.js');
require('./testpackages.js');
window.selectpicker = require('bootstrap-select');

window.help = require('./helpers.js');
require('./promo.js');
require('../../../qform/js/index.js');
import "./TreeHelper.js";

require('./tree_interactive.js');


// require('codemirror/lib/codemirror.js');
require('Plugin/select2.js');
require('select2/dist/js/select2.full.min.js');

require('./swal_resources.js');
require('./alerts.js');

require('./sitemap.js');

// require('./fabricjs/canvas-toBlob.js');
// require('./fabricjs/fabric.min.js');
// require('./fabricjs/FileSaver.min.js');

// require('./tree_of_staff.js');
// import "./testHelper.js";

require('./peity.js');
require('./upload_staff_list.js');
require('./conference.js');

require('./jquery.suggestions.min.js');

// require('./fabricjs/canvas-toBlob.js');
// require('./fabricjs/fabric.min.js');
// require('./fabricjs/FileSaver.min.js');


/***
 <!-- Plugins -->
 <script src="{{ asset('global/vendor/switchery/switchery.js') }}"></script>
 <script src="{{ asset('global/vendor/intro-js/intro.js') }}"></script>
 <script src="{{ asset('global/vendor/screenfull/screenfull.js') }}"></script>
 <script src="{{ asset('global/vendor/slidepanel/jquery-slidePanel.js') }}"></script>
 <script src="{{ asset('global/vendor/chartist/chartist.min.js') }}"></script>
 <script src="{{ asset('global/vendor/chartist-plugin-tooltip/chartist-plugin-tooltip.js') }}"></script>
 <script src="{{ asset('global/vendor/jvectormap/jquery-jvectormap.min.js') }}"></script>
 <script src="{{ asset('global/vendor/jvectormap/maps/jquery-jvectormap-world-mill-en.js') }}"></script>
 <script src="{{ asset('global/vendor/matchheight/jquery.matchHeight-min.js') }}"></script>
 <script src="{{ asset('global/vendor/peity/jquery.peity.min.js') }}"></script>
 <script src="{{ asset('global/vendor/bootstrap-select/bootstrap-select.js') }}"></script>
 <script src="{{ asset('global/vendor/stickyfill/stickyfill.js') }}"></script>
 <script src="{{asset('global/vendor/footable/footable.min.js')}}"></script>
 ***/
toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": true,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

window.axios = require('axios').default;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vue = require('vue');

const analyticsAndEducationVueApp = new Vue({
    el: '.page-content',
    components: {
        'home-page': require('./components/home/HomePage.vue').default,
        'education-page': require('./components/Education/EducationPage.vue').default
    }
});

const notificationBellVueApp = new Vue({
    el: 'nav#SiteNavBar',
    components: {
        'notification-bell': require('./components/NotificationBell/NotificationBell.vue').default
    }
});
